import userInfoActionsTypes from "../actions/userInfoActionsTypes";
import { reducerFactory } from "./reducerFactory";

export const userInfoReducer = reducerFactory.crudReducer(userInfoActionsTypes);
